import { RootState } from "../../store";
import { Account } from "../../../services/cloudchipr.api";

export const currentAccountSelector = (state: RootState): Account | null =>
  state.accountSetup.account;
